import { combineReducers, configureStore } from '@reduxjs/toolkit';
import { createWrapper } from 'next-redux-wrapper';
import test, { TestData } from 'app/redux/test';
import { GlobalData } from 'types/commons';
import { Category } from 'types/category';
import commons from 'app/redux/commons';
import global from 'app/redux/global';
import blogs from 'app/redux/blogs';
import { Blog } from 'types/blog';
import env from '.env.json';

export const makeStore = () => {
  return configureStore({
    reducer: combineReducers({
      commons,
      global,
      blogs,
      test,
    }),
    devTools: env.ENV === 'dev',
  });
}

export interface AppStoreState {
  test: TestData;
  blogs: Blog[];
  global: GlobalData;
  commons: {
    loading: boolean;
    menuVocabularies: Category[],
  }
}

// export an assembled wrapper
export type AppStore = ReturnType<typeof makeStore>;
// export an assembled wrapper
export const wrapper = createWrapper<AppStore>(makeStore, { debug: false });
